<template>
    <settings-popup-base
        :resources="{ 
            deleteButtonText: resource('JourneyBuilder_Button_DeleteCheckpoint'),  
            ...resources 
        }"
        :invalid="invalid"
        
        @hide="onHide($event)"
        @hidden="$emit('hidden')"
        @save="$emit('save')"
        @delete="deleteCheckpointWithPrompt()"
        @display-errors="$emit('display-errors')"
    >
        <template #title>
            <slot name="title" />
        </template>
        
        <template #body>
            <slot name="body" />

            <template v-if="canWrite && commentId">
                <hr />
                <h4>{{resource("JourneyBuilder_JourneyBrick_CommentHeader")}}</h4>
                <new-comment :brickId="commentId" id="newcomment" />
            </template>
        </template>
    </settings-popup-base>
</template>

<script>
import { promptYesNo } from '@modules/JourneyBuilder/Util/prompt';

import resourceMixin from '@core/Util/Mixins/resources';
import permissionsMixin from '@modules/JourneyBuilder/Mixins/journey-permissions';

import SettingsPopupBase from "./SettingsPopupBase";
import {NewComment} from '@modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Comments';

export default {
    name: "connection-settings-popup",
    components: {
        SettingsPopupBase,
        NewComment
    },
    mixins: [permissionsMixin, resourceMixin],
    
    props: {
        /**
         * @property {String} deletePromptTitle
         * @property {String} deletePromptBody
         * @property {String} deleteButtonText
         */
        resources: {
            type: Object,
            required: true
        },
        
        isNew: {
            type: Boolean,
            default: false,
            required: false
        },
        
        invalid: {
            type: Boolean,
            default: false,
            required: false
        },
        
        commentId: {
            type: String,
            required: false
        }
    },

    methods: {
        onHide(evt){
            if(this.isNew){
                //Cancel selected - ask prior to actually removing checkpoint
                evt.continueAfter(async () => {
                    try {
                        await promptYesNo(
                            this.resource('JourneyComposer_CheckpointModal_CancelNewCheckpoint_Title'),
                            this.resource('JourneyComposer_CheckpointModal_CancelNewCheckpoint_Body')
                        );

                        this.deleteCheckpoint();
                    } catch(e) {
                        evt.preventDefault();
                    }
                });
            }
        },

        async deleteCheckpointWithPrompt(){
            try {
                await promptYesNo(
                    this.resources.deletePromptTitle,
                    this.resources.deletePromptBody
                );
            } catch(e) {
                //Cancelled - swallow and back out
                return;
            }

            this.deleteCheckpoint();
        },

        deleteCheckpoint() {
            this.$emit('delete');
        }
    }
}
</script>
